import React, { useCallback } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { set } from "@totalsoft/react-state-lens";
import { useTranslation } from "react-i18next";
import { PRODUCT_SCHEDULE } from "features/products/queries";
import { useQueryWithErrorHandling } from "hooks/errorHandling";
import productPageStyle from "features/products/styles";
import { paymentSchedule } from "constants/paymentSchedule";
import { LoadingFakeText } from "@totalsoft/rocket-webapp-components-deprecated";
import { Close } from "@material-ui/icons";
import { emptyString } from "constants/defaultValues";
import { displayFormat } from "features/common/constants";

const useStyles = makeStyles(productPageStyle);

function ProductSchedule({ showLens, quoteProductId }) {
  const { t } = useTranslation();
  const classes = useStyles();

  const { data } = useQueryWithErrorHandling(PRODUCT_SCHEDULE, { variables: { quoteProductId } });

  const handleClose = useCallback(() => {
    (showLens |> set)(false);
  }, [showLens]);

  return (
    <Dialog maxWidth="xl" open={true} onClose={handleClose}>
      <DialogTitle>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant="h4">{t("Product.Schedule")}</Typography>
          </Grid>
          <Grid item>
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent dividers>
        {!data && <LoadingFakeText lines={5}></LoadingFakeText>}
        {data && (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className={classes.scheduleHeaderStyle}>#</TableCell>
                {data?.quoteProduct.productSchedule.columnDefinitions.map((item, index) => (
                  <TableCell className={classes.scheduleHeaderStyle} key={index}>
                    {item.columnCaption}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.quoteProduct.productSchedule.scheduleLines.map((scheduleLine, index) => (
                <TableRow key={index}>
                  <TableCell className={classes.scheduleStyle}>{index + 1}</TableCell>
                  {scheduleLine.values
                    .filter((x) => x.columnCaption !== emptyString)
                    .map((scheduleLineCell, index) => (
                      <TableCell className={classes.scheduleStyle} key={index}>
                        {scheduleLineCell.systemTypeName === paymentSchedule.date
                          ? t("DATE_FORMAT", {
                              date: { value: scheduleLineCell.value, format: "DD.MM.YYYY" },
                            })
                          : scheduleLineCell.systemTypeName === paymentSchedule.decimal &&
                            scheduleLineCell.displayFormat === displayFormat.decimalFourDigits
                          ? t("DECIMAL4", { number: scheduleLineCell.value })
                          : scheduleLineCell.systemTypeName === paymentSchedule.decimal &&
                            scheduleLineCell.displayFormat === displayFormat.decimalTwoDigits
                          ? t("DECIMAL", { number: scheduleLineCell.value })
                          : scheduleLineCell.value}
                      </TableCell>
                    ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClose} color="primary">
          {t("General.Close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ProductSchedule.propTypes = {
  showLens: PropTypes.object.isRequired,
  quoteProductId: PropTypes.number.isRequired,
};

export default ProductSchedule;
